<div class="modal-wrapper">
  <div class="overlay" *ngIf="showLoader">
    <app-spinner></app-spinner>
  </div>
  <div class="add-filter-header modal-header">
    <h4 class="modal-title" id="modal-basic-title">Scrape Preferences</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div>
    <h5
      class="mt-3 heading-class"
      title="If scraper tool will find selected pages - it will stop scraping further, otherwise it will extend scraping accordingly to  Scraping Parameters"
    >
      Limit Scraping to Selected Pages
    </h5>
    <div class="form-check-inline">
      <div class="form-check form-check-inline" *ngFor="let item of limitScraping">
        <input class="form-check-input custom-checkbox" type="checkbox" value="" id="contactLocationCheck" [(ngModel)]="item.checked" />
        <label class="form-check-label" for="contactLocationCheck"> {{ item.label }} </label>
      </div>
    </div>

    <h5 class="mt-3 heading-class" title="Define maximum scraping depth and maximum number of pages that should be scraped">Scraping Parameters</h5>
    <div class="scraping-params">
      <div class="form-group scraping-param">
        <label for="depthToScrape">Depth to Scrape</label>
        <input
          type="number"
          class="form-control scarping-input"
          id="depthToScrape"
          placeholder="Enter depth to scrape"
          [(ngModel)]="depthToScrape"
          pattern="[1-9][0-9]*"
          (input)="onDepthToScrapeChange()"
        />
        <div class="error-message" *ngIf="depthToScrapeInvalid">Please enter a positive integer value.</div>
      </div>
      <div class="form-group scraping-param">
        <label for="numberOfPages">Number of Pages</label>
        <input
          type="number"
          class="form-control scarping-input"
          id="numberOfPages"
          placeholder="Enter number of pages"
          [(ngModel)]="numberOfPages"
          pattern="[1-9][0-9]*"
          (input)="onNumberOfPagesChange()"
        />
        <div class="error-message" *ngIf="numberOfPagesInvalid">Please enter a positive integer value.</div>
      </div>
    </div>
    <h5 class="mt-3 heading-class optional-settings-heading" title="Optional Settings">Optional Settings</h5>
    <div class="modal-body ey-add-filter-body">
      <div class="keyword-selection-container">
        <div class="row">
          <div class="col-8">
            <div class="row">
              <div class="col-12">
                <h5 class="mt-3 heading-class select-keyword-heading" title="Enter or Select keywords to highlight">
                  Enter or Select keywords to highlight
                </h5>
              </div>
            </div>
            <div class="row optional-text">
              <div class="col-12">Optional</div>
            </div>
          </div>
          <div class="col-4 text-right align-self-center">
            <a class="clear-all-button" (click)="onClearAll()">
              <i class="material-icons clear-all-icon">block</i>
              Clear All
            </a>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="keyword-selection">
              <div class="row">
                <div class="col-12">
                  <h5 class="mt-3 heading-class custom-keyword" title="Custom Keywords">Custom Keywords</h5>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <span class="ey-float-label">
                    <input
                      type="text"
                      class="form-control"
                      id="customKeywordsInclude"
                      name="customKeywordsInclude"
                      [(ngModel)]="keywordsInclude"
                      #customKeywords="ngModel"
                      maxlength="255"
                      [disabled]="readOnly"
                      appLabelFloat
                    />
                    <label for="newSubsetName">Enter Multiple Keywords To Include</label>
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <span class="ey-float-label">
                    <input
                      type="text"
                      class="form-control"
                      id="customKeywordsExclude"
                      name="customKeywordsExclude"
                      [(ngModel)]="keywordsExclude"
                      #customKeywords="ngModel"
                      maxlength="255"
                      [disabled]="readOnly"
                      appLabelFloat
                    />
                    <label for="newSubsetName">Enter Multiple Keywords To Exclude</label>
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h5 class="mt-3 heading-class custom-keyword" title="Keywords List">Keywords List</h5>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <span class="ey-float-label">
                      <!-- Need to verify effect of removal of (change)="industryTypeChange()" from below -->
                      <p-multiSelect
                        class="form-control"
                        id="productIncludeList"
                        name="productIncludeList"
                        [disabled]="readOnly"
                        [options]="productIncludeListOptions"
                        [(ngModel)]="selectedProductList"
                        #productIncludeList="ngModel"
                        [defaultLabel]="''"
                        appLabelFloat
                        [ngClass]="{ 'ey-multiselect-filled': selectedProductList?.length }"
                      >
                      </p-multiSelect>
                      <label for="productIncludeList">Product Include List</label>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <span class="ey-float-label">
                      <!-- Need to verify effect of removal of (change)="industryTypeChange()" from below -->
                      <p-multiSelect
                        class="form-control"
                        id="functionIncludeList"
                        name="functionIncludeList"
                        [disabled]="readOnly"
                        [options]="functionIncludeListOptions"
                        [(ngModel)]="selectedFunctionList"
                        #functionIncludeList="ngModel"
                        [defaultLabel]="''"
                        [ngClass]="{ 'ey-multiselect-filled': selectedFunctionList?.length }"
                        appLabelFloat
                      >
                      </p-multiSelect>
                      <label for="functionIncludeList">Function Include List</label>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <span class="ey-float-label">
                      <!-- Need to verify effect of removal of (change)="industryTypeChange()" from below -->
                      <p-multiSelect
                        class="form-control"
                        id="excludeList"
                        name="excludeList"
                        [disabled]="readOnly"
                        [options]="excludeListOptions"
                        [(ngModel)]="selectedExcludeList"
                        #excludeList="ngModel"
                        [defaultLabel]="''"
                        [ngClass]="{ 'ey-multiselect-filled': selectedExcludeList?.length }"
                        appLabelFloat
                      >
                      </p-multiSelect>
                      <label for="excludeList">Exclude List</label>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer ey-add-filter-footer">
      <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="readOnly" (click)="onRunScrapeClick()">Scrape Selected Companies</button>
    </div>
  </div>
</div>
